/**
 * Get current location
 */
export function getCurrentLocation(): Location {
  return window.location;
}

/**
 * Get current URL for redirect purposes
 */
export function getCurrentUrl(): string {
  const location = getCurrentLocation();
  return location.origin + location.pathname;
}

/**
 * Get current URL for redirect purposes
 */
export function getCurrentDomain(append = '/'): string {
  const location = getCurrentLocation();
  return location.origin + append;
}

export default {
  getCurrentLocation,
  getCurrentUrl,
  getCurrentDomain,
};
